module.exports = __webpack_public_path__ + "img/Vitoshka.2edf558e.jpg";